/* PRESTIA – Guard + Contextos Nacional/Wholesale + tipo_usuario
   Requiere:
   - xcs_data.js (selectores y render de precios)
   - theme.liquid (redirige index a /collections/all)
*/

(function () {
  // -----------------------
  // 0) Utilidades
  // -----------------------
  const LS_AUTH_KEY   = 'prestia_auth';
  const LS_CTX_KEY    = 'navega_en';      // "nacional" | "wholesale"
  const LS_USER_TYPE  = 'tipo_usuario';   // "comercial" | "visitante"
  const AUTH_TTL_MS   = 24 * 60 * 60 * 1000; // 24h opcional
  const LS_PRICE_TYPE = 'pricetype';      // guarda pricetype en localStorage
  const RAI_CLAVES = [
    '3044646996',
    '3045517029',
    '3014772878',
    '3226065759',
    '3044750722',
    '3017072484',
    '3104231722',
    '3014596862',
    '3107590158',
    '3505142849',
    '3014596846',
    '3246871206',
    '3052600011',
    '3148022953',
    '3196773465',
    '3132052412',
    '3165029250',
  ];

  const pathname = () => location.pathname || '/';
  const isHome = () => {
    const p = pathname().replace(/\/+$/,''); // normaliza trailing slash
    return p === '' || p === '/' || p === '/collections/all';
  };

  // Helper: obtener pricetype de la URL (solo valores permitidos)
  const getPriceTypeFromURL = () => {
    const params = new URLSearchParams(location.search);
    const v = params.get('pricetype');
    const valid = ['dolares', 'mayorista', 'outlet'];
    return valid.includes(v) ? v : null;
  };

  // Helpers para localStorage de pricetype
  const setPriceType = (pt) => {
    const valid = ['dolares', 'mayorista', 'outlet'];
    if (valid.includes(pt)) localStorage.setItem(LS_PRICE_TYPE, pt);
  };
  const getPriceType = () => {
    const valid = ['dolares', 'mayorista', 'outlet'];
    const pt = localStorage.getItem(LS_PRICE_TYPE);
    return valid.includes(pt) ? pt : null;
  };

  // Clase en body para pricetype
  function removeBodyPriceTypeClass() {
    document.body.classList.remove('pricetype-dolares','pricetype-mayorista','pricetype-outlet');
  }
  function applyBodyPriceTypeClass(pt) {
    removeBodyPriceTypeClass();
    if (pt) document.body.classList.add(`pricetype-${pt}`);
  }

  // Helper: obtener valor de precio personalizado desde la fila según pricetype
  function getCustomPriceValueFromRow(el, pt) {
    let attr = '';
    if (pt === 'dolares') attr = 'data-custom-price-dolares';
    else if (pt === 'mayorista') attr = 'data-custom-price-mayorista';
    else if (pt === 'outlet') attr = 'data-custom-price-promo';
    const vStr = el ? el.getAttribute(attr) : null;
    const vNum = vStr != null ? Number(vStr) : null;
    return Number.isFinite(vNum) ? vNum : null;
  }
  const isCollection = () => pathname().startsWith('/collections/');
  const isNacional   = () => pathname().startsWith('/collections/nacional');
  const isWholesale  = () => pathname().startsWith('/collections/wholesale');
  const isOutlet     = () => {
    // Método infalible: verificar si el body tiene la clase 'catalogo-outlet'
    if (document.body && document.body.classList.contains('catalogo-outlet')) {
      return true;
    }
    
    // Método de respaldo: verificar URL (por si acaso)
    const path = pathname();
    return path.startsWith('/collections/outlet') || 
           (path === '/collections/outlet' || path.includes('/collections/outlet/')) ||
           (location.href.includes('/collections/outlet'));
  };
  const isPublicCtx  = () => isNacional() || isWholesale() || isOutlet();

  const now = () => Date.now();
  const saveAuth = (clave) =>
    localStorage.setItem(LS_AUTH_KEY, JSON.stringify({ ok: true, clave, ts: now() }));
  const loadAuth = () => {
    try { return JSON.parse(localStorage.getItem(LS_AUTH_KEY) || 'null'); }
    catch(_) { return null; }
  };
  const isAuthValid = () => {
    const data = loadAuth();
    if (!data || !data.ok) return false;
    if (AUTH_TTL_MS && now() - (data.ts || 0) > AUTH_TTL_MS) return false;
    return true;
  };

  const setCtx   = (ctx) => localStorage.setItem(LS_CTX_KEY, ctx);
  const getCtx   = () => localStorage.getItem(LS_CTX_KEY);
  const clearCtx = () => localStorage.removeItem(LS_CTX_KEY);

  const setUserType   = (t) => localStorage.setItem(LS_USER_TYPE, t);
  const getUserType   = () => localStorage.getItem(LS_USER_TYPE);
  const clearUserType = () => localStorage.removeItem(LS_USER_TYPE);

  const normalizeClave = (inp) => {
    let digits = String(inp || '').replace(/\D+/g, '');
    if (digits.length === 12 && digits.startsWith('57')) digits = digits.slice(2);
    return digits;
  };

  // -----------------------
  // 1) Modal de acceso
  // -----------------------
  function ensureStyles() {
    if (document.getElementById('prestia-guard-styles')) return;
    const s = document.createElement('style');
    s.id = 'prestia-guard-styles';
    s.textContent = `
      .pg-backdrop{position:fixed;inset:0;background:#000;display:flex;align-items:center;justify-content:center;z-index:99999}
      .pg-modal{background:#fff;max-width:420px;width:92%;border-radius:12px;padding:20px;box-shadow:0 10px 30px #00000033;font-family:system-ui,-apple-system,Segoe UI,Roboto}
      .pg-title{font-size:18px;font-weight:700;margin:0 0 8px}
      .pg-desc{font-size:14px;color:#444;margin:0 0 16px}
      .pg-row{display:flex;gap:8px}
      .pg-input{flex:1;padding:10px;border:1px solid #ddd;border-radius:8px;font-size:16px}
      .pg-btn{padding:10px 14px;border:0;border-radius:8px;background:#111;color:#fff;font-weight:600;cursor:pointer}
      .pg-error{color:#c00;margin-top:10px;font-size:13px;min-height:18px}
    `;
    document.head.appendChild(s);
  }

  function showAuthModal() {
    ensureStyles();
    const backdrop = document.createElement('div');
    backdrop.className = 'pg-backdrop';
    backdrop.innerHTML = `
      <div class="pg-modal" role="dialog" aria-modal="true" aria-label="Acceso">
        <h3 class="pg-title">Acceso autorizado</h3>
        <p class="pg-desc">Ingresa tu clave para continuar.</p>
        <div class="pg-row">
          <input class="pg-input" type="password" inputmode="numeric" pattern="[0-9]*" maxlength="10" placeholder="Clave" />
          <button class="pg-btn">Entrar</button>
        </div>
        <div class="pg-error"></div>
      </div>
    `;
    const input = backdrop.querySelector('.pg-input');
    const btn   = backdrop.querySelector('.pg-btn');
    const err   = backdrop.querySelector('.pg-error');

    function tryLogin() {
      const clave = normalizeClave(input.value);
      if (!clave) { err.textContent = 'Ingresa una clave válida.'; return; }
      if (RAI_CLAVES.includes(clave)) {
        saveAuth(clave);
        setUserType('comercial');   // ✅ usuario autenticado por clave (celular en RAI)
        document.body.removeChild(backdrop);
      } else {
        err.textContent = 'Clave no autorizada.';
      }
    }

    btn.addEventListener('click', tryLogin);
    input.addEventListener('keydown', (e) => { if (e.key === 'Enter') tryLogin(); });

    document.body.appendChild(backdrop);
    input.focus();
  }

  // -----------------------
  // 2) Clases de contexto en <body>
  // -----------------------
  function addBodyCtxClass(ctx) {
    removeBodyCtxClass();
    if (ctx === 'nacional')   document.body.classList.add('catalogo-nacional');
    if (ctx === 'wholesale')  document.body.classList.add('catalogo-wholesale');
    if (ctx === 'outlet')     document.body.classList.add('catalogo-outlet');
  }
  function removeBodyCtxClass() {
    document.body.classList.remove('catalogo-nacional', 'catalogo-wholesale', 'catalogo-outlet');
  }

  function applyBodyContext() {
    if (isHome()) {
      clearCtx();
      clearUserType();
      removeBodyCtxClass();
      return;
    }
    if (isNacional()) {
      setCtx('nacional');
      setUserType('visitante');      // ✅ acceso público por Nacional
      addBodyCtxClass('nacional');
      return;
    }
    if (isWholesale()) {
      setCtx('wholesale');
      setUserType('visitante');      // ✅ acceso público por Wholesale
      addBodyCtxClass('wholesale');
      return;
    }
    if (isOutlet()) {
      setCtx('outlet');
      setUserType('visitante');      // ✅ acceso público por Outlet (sin autenticación)
      addBodyCtxClass('outlet');
      return;
    }
    const saved = getCtx();
    if (saved) addBodyCtxClass(saved);
  }

  // -----------------------
  // 3) Ocultar filas de precio según contexto
  // -----------------------
  function hidePriceRows() {
    // Prioridad: usar pricetype efectivo desde almacenamiento (seteado en boot)
    const priceType = getPriceType();
    if (priceType) {
      // Ocultar todas las filas
      document.querySelectorAll('#data_precio_dolares, #data_precio_mayorista, #data_precio_detal, #data_precio_promo')
        .forEach(el => el && (el.style.display = 'none'));

      // Mostrar solo la fila correspondiente si el precio no es 0
      let targetSelector = '';
      if (priceType === 'dolares') targetSelector = '#data_precio_dolares';
      else if (priceType === 'mayorista') targetSelector = '#data_precio_mayorista';
      else if (priceType === 'outlet') targetSelector = '#data_precio_promo';

      if (targetSelector) {
        // Refactor: evaluar por contenedor de producto para evitar problemas con IDs duplicados
        document.querySelectorAll('.m-product-item').forEach(container => {
          const row = container.querySelector(targetSelector);
          if (!row) return; // si el contenedor no tiene la fila esperada
          const priceVal = getCustomPriceValueFromRow(row, priceType);
          if (priceVal === 0) {
            row.style.display = 'none';
            container.classList.add('none');
          } else {
            row.style.display = '';
            container.classList.remove('none');
          }
        });
      }
      return; // No continuar con lógica de contexto si hay pricetype efectivo
    }

    // 2) Sin pricetype: usar contexto y tipo de usuario
    const ctx = getCtx();
    const userType = getUserType();
    
    if (ctx === 'nacional') {
      // Nacional: oculta dólares y outlet
      document.querySelectorAll('#data_precio_dolares, #data_precio_promo').forEach(el => el && (el.style.display = 'none'));
    } else if (ctx === 'wholesale') {
      // Wholesale: oculta mayorista, detal y outlet
      document.querySelectorAll('#data_precio_mayorista, #data_precio_detal, #data_precio_promo').forEach(el => el && (el.style.display = 'none'));
    } else if (ctx === 'outlet') {
      // Outlet: solo muestra precio promo, oculta todos los demás
      document.querySelectorAll('#data_precio_mayorista, #data_precio_dolares, #data_precio_detal').forEach(el => el && (el.style.display = 'none'));
    } else {
      // Usuarios logueados: mostrar todos los precios si es comercial, sino ocultar outlet
      if (userType === 'comercial') {
        // Comercial logueado: ve todos los precios
        document.querySelectorAll('#data_precio_dolares, #data_precio_mayorista, #data_precio_detal, #data_precio_promo').forEach(el => el && (el.style.display = ''));
      } else {
        // Visitante sin contexto específico: ocultar precio outlet
        document.querySelectorAll('#data_precio_dolares, #data_precio_mayorista, #data_precio_detal').forEach(el => el && (el.style.display = ''));
        document.querySelectorAll('#data_precio_promo').forEach(el => el && (el.style.display = 'none'));
      }
    }
  }

  function observePriceBlocks() {
    const obs = new MutationObserver(() => hidePriceRows());
    obs.observe(document.body, { childList: true, subtree: true });
  }

  // -----------------------
  // 4) Filtros → tags en la misma colección pública
  // -----------------------

  function slugifyTag(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\w]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function setupLockedFilters() {
    if (!isPublicCtx()) return;

    const handle = isNacional() ? 'nacional' : isWholesale() ? 'wholesale' : 'outlet';
    const selSize = document.getElementById('tallasTopSelect');
    const selColor= document.getElementById('colorTopSelect');
    const btn     = document.getElementById('encuentraTutalla');

    // Función para convertir valores de filtros a tags de Shopify
    function convertToShopifyTag(value, type) {
      if (!value) return '';
      
      if (type === 'size') {
        // Convertir "M(10)" a "m10"
        const match = value.match(/^([A-Z]+)\((\d+)\)$/);
        if (match) {
          return match[1].toLowerCase() + match[2];
        }
        return slugifyTag(value);
      } else if (type === 'color') {
        // Para colores, extraer el valor después de "constraint="
        if (value.startsWith('constraint=')) {
          return value.replace('constraint=', '');
        }
        return slugifyTag(value);
      }
      return slugifyTag(value);
    }

    function buildTagsURL() {
      if (isOutlet()) {
        // Para outlet, usar formato de tags: /collections/outlet/categoria+talla+color
        return buildOutletTagsURL();
      } else {
        // Para otros contextos, usar el formato original
        const tags = [];
        if (selColor && selColor.value) {
          const opt = selColor.options[selColor.selectedIndex];
          if (opt && opt.text) tags.push(slugifyTag(opt.text));
        }
        if (selSize && selSize.value) {
          const opt = selSize.options[selSize.selectedIndex];
          if (opt && opt.text) tags.push(slugifyTag(opt.text));
        }
        const base = `${location.origin}/collections/${handle}`;
        const tagPath = tags.length ? `/${tags.join('+')}` : '';
        const currentPriceType = getPriceType() || 'mayorista';
        const priceTypeParam = currentPriceType ? `&pricetype=${currentPriceType}` : '';
        return `${base}${tagPath}?sort_by=title-descending${priceTypeParam}`;
      }
    }

    function buildOutletTagsURL() {
      const tags = [];
      
      // Obtener categoría seleccionada
      let categoryTag = '';
      if (selCategory && selCategory.value) {
        // Extraer la categoría de la URL del select
        const match = selCategory.value.match(/\/collections\/outlet\/([^?]+)/);
        if (match) {
          categoryTag = match[1]; // Ya viene en formato "categoria+singular"
        } else {
          // Si no es una URL de outlet, extraer la categoría base
          const categoryMatch = selCategory.value.match(/\/collections\/([^?]+)/);
          if (categoryMatch) {
            const categoryKey = categoryMatch[1];
            categoryTag = categoryKey;
          }
        }
      }
      
      // Si hay categoría, agregarla como primer tag
      if (categoryTag) {
        tags.push(categoryTag);
      }
      
      // Agregar talla como tag
      if (selSize && selSize.value) {
        const sizeTag = convertToShopifyTag(selSize.value, 'size');
        if (sizeTag) tags.push(sizeTag);
      }
      
      // Agregar color como tag
      if (selColor && selColor.value) {
        const colorTag = convertToShopifyTag(selColor.value, 'color');
        if (colorTag) tags.push(colorTag);
      }
      
      // Construir URL final
      const base = `${location.origin}/collections/outlet`;
      const tagPath = tags.length ? `/${tags.join('+')}` : '';
      const currentPriceType = getPriceType() || 'mayorista';
      const priceTypeParam = currentPriceType ? `&pricetype=${currentPriceType}` : '';
      const finalURL = `${base}${tagPath}?sort_by=title-descending${priceTypeParam}`;
      
      console.log('🏗️ Construyendo URL de outlet:', {
        categoryTag,
        sizeValue: selSize?.value,
        colorValue: selColor?.value,
        tags,
        finalURL
      });
      
      return finalURL;
    }

    // Manejar cambio de categoría
    if (selCategory) {
      selCategory.addEventListener('change', (e) => {
        if (isOutlet()) {
          // Para outlet, no navegar inmediatamente, sino actualizar el botón
          console.log('🔄 Categoría cambiada en outlet, actualizando botón...');
          if (btn) {
            btn.setAttribute('href', buildOutletTagsURL());
          }
        } else {
          // Para otros contextos, navegar inmediatamente
          const selectedValue = e.target.value;
          if (selectedValue) {
            location.href = selectedValue;
          }
        }
      });
    }

    // Manejar cambios en talla y color para outlet
    if (isOutlet()) {
      [selSize, selColor].forEach(select => {
        if (select) {
          select.addEventListener('change', () => {
            console.log('🔄 Filtro cambiado en outlet, actualizando botón...');
            if (btn) {
              btn.setAttribute('href', buildOutletTagsURL());
            }
          });
        }
      });
    }

    if (btn) {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        location.href = buildTagsURL();
      });
    }
  }

  // -----------------------
  // 5) Función para ajustar columnas en móvil
  // -----------------------
  function adjustMobileColumns() {
    // Verificar si estamos en versión móvil
    if (document.body && document.body.hasAttribute('data-browser-cel')) {
      console.log('📱 Detectada versión móvil, ajustando columnas...');
      
      // Buscar elementos con la clase .m-collection-products
      const collectionElements = document.querySelectorAll('.m-collection-products');
      
      if (collectionElements.length > 0) {
        console.log(`🔍 Encontrados ${collectionElements.length} elementos .m-collection-products`);
        
        collectionElements.forEach((element, index) => {
          // Verificar si tiene la clase m-cols-1
          if (element.classList.contains('m-cols-1')) {
            console.log(`📝 Elemento ${index}: Reemplazando m-cols-1 por m-cols-2`);
            
            // Quitar m-cols-1 y agregar m-cols-2
            element.classList.remove('m-cols-1');
            element.classList.add('m-cols-2');
            
            console.log(`✅ Elemento ${index}: Clases actualizadas`);
          } else {
            console.log(`ℹ️ Elemento ${index}: No tiene la clase m-cols-1`);
          }
        });
      } else {
        console.log('❌ No se encontraron elementos con la clase .m-collection-products');
      }
    } else {
      console.log('💻 No es versión móvil, no se requieren ajustes de columnas');
    }
  }

  // -----------------------
  // 6) Boot
  // -----------------------
  function boot() {
    // Redirigir /outlet a /collections/outlet
    if (pathname() === '/outlet') {
      location.href = '/collections/outlet';
      return;
    }

    applyBodyContext();

    // Determinar y persistir pricetype (URL > storage > default mayorista)
    const urlPT = getPriceTypeFromURL();
    let effectivePT;
    if (urlPT) {
      setPriceType(urlPT);
      effectivePT = urlPT;
    } else {
      effectivePT = getPriceType();
      if (!effectivePT) {
        effectivePT = 'mayorista';
        setPriceType(effectivePT);
      }
    }
    applyBodyPriceTypeClass(effectivePT);

    if (isHome()) {
      if (!isAuthValid()) showAuthModal();
    } else {
      if (!isAuthValid() && !getCtx()) showAuthModal();
    }

    hidePriceRows();
    observePriceBlocks();
    setupLockedFilters();
    
    // Ajustar columnas en móvil después de un pequeño delay
    setTimeout(() => {
      adjustMobileColumns();
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();